import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteMember, getMembers } from '../../store/actions/member/member.action';
import MemberList from '../../components/Member/Members';
import PageLoader from '../../components/Common/PageLoader';

const PiecesInstrumentContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const members = useSelector((state) => state.member.list);
  const isFetching = useSelector((state) => state.member.isFetching);
  const categories = useSelector((state) => state.auth.categories);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      const memberCategory = categories.find((category) => category.link === 'members');
      if (memberCategory) {
        setMode(memberCategory.mode);
        setAccessDenied(false);
      } else {
        throw new Error('Member category not found');
      }
    } catch (err) {
      setAccessDenied(true);
    }
  }, [categories]);

  // Handle delete member
  const handleDeleteMember = useCallback((member) => {
    dispatch(deleteMember(member));
  }, [dispatch]);

  // Initialize on mount
  useEffect(() => {
    dispatch(getMembers());
    setAccess();
  }, [dispatch, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Access denied state
  if (accessDenied) {
    return <div>This category is not accessible to the logged in user.</div>;
  }

  // Prepare member info object
  const memberInfo = {
    deleteMember: handleDeleteMember,
    members
  };

  return (
    <section>
      <MemberList mode={mode} memberInfo={memberInfo} />
    </section>
  );
};

export default PiecesInstrumentContainer;
